<template>
  <div :style="themeStyle">
    <div>
        <v-row class="headline1_bg p-3" no-gutters>
          <v-col cols="12" :style="'color: ' + $textcolor">
            {{ $t("message.promotion") }}
          </v-col>
        </v-row>
        <br>
        <all-promotion levelById="levelById"></all-promotion>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AllPromotion from '../AllPromotion'

export default {
  name: 'Reward',
  components: {
    'all-promotion': AllPromotion
  },
  data () {
    return {
      member: null,
      profile: null,
      levelById: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Promotion/Promotion.vue